"use client";
import dynamic from "next/dynamic";

/**
 * `SiteGoogleMap`, deferred until a map actually mounts.
 *
 * PERF: `@react-google-maps/api` is 332KB of source and used to sit in an
 * every-page chunk (measured: `4e6af11a-*.js`, 145,217B, eager on every
 * `/[lang]/*` route — the single largest client dependency in the app). It got
 * there through the form builder, not through the map pages:
 *
 *   CommonFormBuilder.tsx -> MapLocation.tsx -> Map.tsx -> SiteGoogleMap.tsx
 *
 * `CommonFormBuilder` renders tenant-configured forms on contact-us, product
 * custom fields, checkout and the address book, so every route that rendered
 * ANY builder form paid for the maps SDK — whether or not that form had a
 * location field.
 *
 * Import this instead of `SiteGoogleMap` at every call site. `LoadScript` lives
 * inside `SiteGoogleMap`, so deferring the component also defers the Google JS
 * API request itself.
 *
 * `ssr: false` costs nothing here: `SiteGoogleMap` renders `null` until
 * `useGetUserLocation` resolves, so it never contributed server markup.
 */
const LazySiteGoogleMap = dynamic(() => import("./SiteGoogleMap"), {
  ssr: false,
});

export default LazySiteGoogleMap;
